import React, { Component } from 'react';
import { connect } from 'react-redux';
import './UserManagedPopResetPasswordComponent.css';
import { Button, TextField } from '@material-ui/core';
import validator, { VALIDATOR_CONST } from '../../../common/validator';
import { INFO, ERROR } from '../../../common/message';
import { getMessage } from '../../../common/util';
import { INPUT } from '../../../common/const';
import {
  setSystemLodingFLg,
  setErrPopMsg,
  setConfirmPopFlg,
  setPasswordPopFlg,
  setPopMessage,
  setOnClickYesFunction,
  setOnClickNoFunction,
  setInfoMessage,
  getUserInfo,
  setErrorMessage,
} from '../../actions/CommonAction';
import {
  setPasswordResetPopFlg,
  executePasswordReset,
  setResetUserList,
} from '../../actions/UserManagedAction';

class UserManagedPopResetPasswordComponent extends Component {
  constructor() {
    super();
    this.state = {
      newPassword: null,
      newPasswordConfirm: null,
      errNewPassword: null,
      errNewPasswordConfirm: null,
    };
  }

  /**
   * stateの初期化
   */
  initState = () => {
    const {
      setErrPopMsgAct,
      setConfirmPopFlgAct,
    } = this.props;
    setErrPopMsgAct(null);
    setConfirmPopFlgAct(false);

    this.setState({ newPassword: null });
    this.setState({ newPasswordConfirm: null });
    this.setState({ errNewPassword: null });
    this.setState({ errNewPasswordConfirm: null });
  }

  /**
   * 新規パスワードバリデーションチェック
   */
  onBlurNewPassword = () => {
    const {
      newPassword,
    } = this.state;

    // 新規パスワードの入力チェック
    const msgs = [];
    this.checkNewPassword(
      newPassword, msgs,
    );
  }

  /**
  * 新規パスワード(確認用)バリデーションチェック
  */
  onBlurNewPasswordConfirm = () => {
    const {
      newPasswordConfirm,
    } = this.state;

    // 新規パスワード(確認用)の入力チェック
    const msgs = [];
    this.checkNewPasswordConfirm(
      newPasswordConfirm, msgs,
    );
  }

  /**
   * 新規パスワードチェック関数
   * 文字種チェック
   * @param {*} newPassword パスワード文字列
   * @param {*} msgs メッセージ
   * @returns 判定結果(true：入力誤り、false：正しい入力)
   */
  checkNewPassword = (newPassword, msgs) => {
    // 新規パスワードの入力チェック
    validator.checkLengthRange(newPassword, 8, 30, msgs);
    validator.checkChar(newPassword, VALIDATOR_CONST.PATERN_PASSWORD, msgs);
    // 入力チェックがあった場合、エラーメッセージを表示
    if (msgs.length !== 0) {
      // エラーメッセージとエラーフラグの設定
      this.setState({ errNewPassword: getMessage(ERROR.E08009, msgs.join(',')) });
      return true;
    }
    // エラーなしの場合
    // エラーメッセージとエラーフラグを解除
    this.setState({ errNewPassword: '' });
    return false;
  }

  /**
 * 新規パスワード(確認用)チェック関数
 * 文字種チェック
 * @param {*} newPasswordConfirm パスワード文字列
 * @param {*} msgs メッセージ
 * @returns 判定結果(true：入力誤り、false：正しい入力)
 */
  checkNewPasswordConfirm = (newPasswordConfirm, msgs) => {
    // 新規パスワードの入力チェック
    validator.checkLengthRange(newPasswordConfirm, 8, 30, msgs);
    validator.checkChar(newPasswordConfirm, VALIDATOR_CONST.PATERN_PASSWORD, msgs);
    // 入力チェックがあった場合、エラーメッセージを表示
    if (msgs.length !== 0) {
      // エラーメッセージとエラーフラグの設定
      this.setState({ errNewPasswordConfirm: getMessage(ERROR.E08009, msgs.join(',')) });
      return true;
    }
    // エラーなしの場合
    // エラーメッセージとエラーフラグを解除
    this.setState({ errNewPasswordConfirm: '' });
    return false;
  }

  /**
   * 変更ボタン押下時の処理
   */
  onClickUpdateButton = () => {
    const {
      newPassword,
      newPasswordConfirm,
    } = this.state;
    const {
      setErrPopMsgAct,
      setConfirmPopFlgAct,
      setPopMessageAct,
      setOnClickYesFunctionAct,
      setOnClickNoFunctionAct,
    } = this.props;
    const msgs = [];
    // 必須チェック
    validator.checkRequired(INPUT.USERMANAGED.NEW_PASSWORD, newPassword, msgs);
    if (msgs.length !== 0) {
      setErrPopMsgAct(msgs);
      this.setState({ errNewPassword: true });
      return;
    }
    validator.checkRequired(INPUT.USERMANAGED.NEW_PASSWORD_CONFIRM, newPasswordConfirm, msgs);
    if (msgs.length !== 0) {
      setErrPopMsgAct(msgs);
      this.setState({ errNewPasswordConfirm: true });
      return;
    }
    if (this.checkNewPassword(
      newPassword, msgs,
    )) {
      return;
    }
    if (this.checkNewPasswordConfirm(
      newPasswordConfirm, msgs,
    )) {
      return;
    }
    // 新規パスワードと新規パスワード(確認用)の同値チェック
    validator.checkDifference(
      INPUT.USERMANAGED.NEW_PASSWORD, INPUT.USERMANAGED.NEW_PASSWORD_CONFIRM,
      newPassword, newPasswordConfirm, msgs,
    );
    if (msgs.length !== 0) {
      setErrPopMsgAct(msgs);
      this.setState({ errNewPassword: true });
      this.setState({ errNewPasswordConfirm: true });
      return;
    }
    // 確認POPUPの表示
    setErrPopMsgAct();
    setPopMessageAct(INFO.I04003);
    setOnClickYesFunctionAct(this.onClickYesButton);
    setOnClickNoFunctionAct();
    setConfirmPopFlgAct(true);
  }

  /**
  * 確認POPUP「はい」選択時の処理
  */
  onClickYesButton = async () => {
    const {
      newPassword,
    } = this.state;
    const {
      resetUserList,
      setPopMessageAct,
      executePasswordResetAct,
      setSystemLodingFlgAct,
      setResetUserListAct,
      setInfoMessageAct,
      setPasswordResetPopFlgAct,
    } = this.props;

    setSystemLodingFlgAct(true);
    setPopMessageAct(INFO.I04001);
    // ユーザーパスワード初期化変更API呼出し
    if (await executePasswordResetAct(resetUserList, newPassword)) {
      // 正常応答が返されたら変更完了メッセージを表示
      setResetUserListAct([]);
      setInfoMessageAct(INFO.I04004);
    } else {
      setSystemLodingFlgAct(false);
      return;
    }
    this.initState();
    setSystemLodingFlgAct(false);
    setPasswordResetPopFlgAct(false);
  }

  /**
   * キャンセルボタン押下時の処理
   */
  onClickCancelButton = () => {
    const {
      setPasswordResetPopFlgAct,
    } = this.props;
    // state初期化
    this.initState();
    setPasswordResetPopFlgAct(false);
  }

  render() {
    const {
      newPassword,
      newPasswordConfirm,
      errNewPassword,
      errNewPasswordConfirm,
    } = this.state;
    const {
      passwordResetPopFlg,
      errPopMsg,
    } = this.props;
    return (
      passwordResetPopFlg && (
        <form>
          <div className="popresetpassword">
            <div className="contents">
              <div className="message1">リセット後のパスワードを入力してください。</div>
              <div className="message2">{errPopMsg}</div>
              <ul className="resetPasswordContent">
                <li className="row">
                  <div className="title">新規パスワード</div>
                  <div className="item">
                    <TextField
                      className="passText"
                      type="password"
                      InputProps={{ classes: { input: 'inputSizing' } }}
                      variant="outlined"
                      margin="normal"
                      value={newPassword || ''}
                      onChange={(ev) => this.setState({ newPassword: ev.target.value })}
                      onBlur={() => this.onBlurNewPassword(this)}
                      error={errNewPassword !== null && errNewPassword !== ''}
                      autoComplete="off"
                    />
                  </div>
                </li>
                <li className="errorRow">
                  <div className="errorDiv">
                    <span className="error">{errNewPassword}</span>
                  </div>
                </li>
                <li className="row">
                  <div className="title">新規パスワード（確認用）</div>
                  <div className="item">
                    <TextField
                      className="passText"
                      type="password"
                      InputProps={{ classes: { input: 'inputSizing' } }}
                      variant="outlined"
                      margin="normal"
                      value={newPasswordConfirm || ''}
                      onChange={(ev) => this.setState({ newPasswordConfirm: ev.target.value })}
                      onBlur={() => this.onBlurNewPasswordConfirm(this)}
                      error={errNewPasswordConfirm !== null && errNewPasswordConfirm !== ''}
                      autoComplete="off"
                    />
                  </div>
                </li>
                <li className="errorRowbottom">
                  <div className="errorDiv">
                    <span className="error">{errNewPasswordConfirm}</span>
                  </div>
                </li>
              </ul>
              <div className="button">
                <Button
                  variant="contained"
                  color="secondary"
                  className="cancel"
                  onClick={() => this.onClickCancelButton(this)}
                >
                  キャンセル
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => this.onClickUpdateButton(this)}
                  disabled={(errNewPassword !== null && errNewPassword !== '')
                    || (errNewPasswordConfirm !== null && errNewPasswordConfirm !== '')}
                >
                  変更
                </Button>
              </div>
            </div>
          </div>
        </form>
      )
    );
  }
}

export default connect(
  (state) => ({
    errPopMsg: state.common.errPopMsg,
    resetUserList: state.usermanaged.resetUserList,
    passwordResetPopFlg: state.usermanaged.passwordResetPopFlg,
  }),
  (dispatch) => ({
    setSystemLodingFlgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setErrPopMsgAct: (str) => dispatch(setErrPopMsg(str)),
    setConfirmPopFlgAct: (bool) => dispatch(setConfirmPopFlg(bool)),
    setPasswordPopFlgAct: (bool) => dispatch(setPasswordPopFlg(bool)),
    setPopMessageAct: (str) => dispatch(setPopMessage(str)),
    setOnClickYesFunctionAct: (func) => dispatch(setOnClickYesFunction(func)),
    setOnClickNoFunctionAct: (func) => dispatch(setOnClickNoFunction(func)),
    setPasswordResetPopFlgAct: (bool) => dispatch(setPasswordResetPopFlg(bool)),
    setInfoMessageAct: (str) => dispatch(setInfoMessage(str)),
    getUserInfoAct: () => dispatch(getUserInfo()),
    setResetUserListAct: (array) => dispatch(setResetUserList(array)),
    setErrorMessageAct: (messages) => dispatch(setErrorMessage(messages)),
    executePasswordResetAct: (
      userList,
      password,
    ) => dispatch(executePasswordReset(userList, password)),
  }),
)(UserManagedPopResetPasswordComponent);
